<template>
  <div class="look-openid">
    <img style="width:66px;height:66px;margin-bottom:24px" :src="data.headimgurl" />
    <div style="margin-bottom:16px">{{data.nickname}}</div>
    <div style="font-weight:bold">
      {{data.openid}}
      <a-button type="link" size="small" v-clipboard:copy="data.openid" v-clipboard:success="onCopy">
        <a-icon type="copy" />复制openid
      </a-button>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'look-openid',

  data() {
    return {
      data: {}
    }
  },

  created() {
    this.isAttention()
  },

  methods: {
    //是否关注公众号
    async isAttention() {
      const code = window.location.href.split('code=')[1].split('&')[0]
      const res = await request({
        url: `/oa/getUserInfo?code=${code}`,
        method: 'get'
      })

      if (res.errcode) {
        this.$message.error(res.errmsg)
      } else {
        if (res.subscribe === 1) {
          this.data = res
        } else {
          window.location.href = 'https://www.aihua-ai.cn:8088'
        }
      }
    },

    onCopy() {
      this.$message.success('复制成功')
    }
  }
}
</script>

<style lang="less" scoped>
.look-openid {
  display: flex;
  flex-direction: column;
  // align-items: center;
  padding-top: 24px;
  padding-left: 24px;
  font-size: 14px;
}
</style>